import { net_filemanage } from "@/api/http";
export const API_STFMFM02C18 = (...params) =>
net_filemanage.post("/api/STFMFM02C18/Initialize", ...params)